import {Component, DestroyRef, effect, inject, OnInit, Signal, signal} from '@angular/core';
import {takeUntilDestroyed, toSignal} from '@angular/core/rxjs-interop';
import {LectionsService} from '../../../core/service/lections/lections.service';
import {Lection} from '../../../core/interface/lections/lections.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {BackButton} from '../../../../assets/shared/back-button/back-button';
import {SafeResourceUrl} from '@angular/platform-browser';
import {VideoConverter} from '../../../core/service/lections/video-converter';
import {catchError} from 'rxjs/operators';
import {EMPTY, firstValueFrom, from, Observable, of} from 'rxjs';
import {ConfirmationModal} from '../../../../assets/shared/modal/confirmation-modal/confirmation-modal';
import {NotificationService} from '../../../../assets/shared/notification/notification.service';
import {ModuleType} from '../../testing/components/interface/testing.interface';
import {AllCourses} from '../../../core/interface/courses/allCourses.interface';
import {CoursesService} from '../../../core/service/courses/allCourses.service';
import {InformationModal} from '../../../../assets/shared/modal/information-modal/information-modal';

@Component({
  selector: 'app-lections',
  imports: [
    BackButton,
    ConfirmationModal,
    InformationModal,
  ],
  providers:[CoursesService],
  templateUrl: './lections.html',
  styleUrl: './lections.scss',
})
export class Lections implements OnInit {
  private lectionsService = inject(LectionsService);
  private destroy = inject(DestroyRef);
  private route = inject(ActivatedRoute);
  private videoConvercer = inject(VideoConverter);
  private router = inject(Router);
  private activeRouter = inject(ActivatedRoute)
  private coursesService = inject(CoursesService)
  private notificationService = inject(NotificationService);
  private activeRoute = inject(ActivatedRoute);
  public lesson = signal<Lection | null>(null);
  public videoUrl = signal< SafeResourceUrl | null>(null);
  public isInformModal = signal<boolean>(false)
  public  isOpen= signal<boolean>(false);
  isShowModal = signal<boolean>(false);
  public titleInformModal = 'После просмотра видео нажмите кнопку «Лекция пройдена» – вам станет доступен следующий урок.'
  public allCourses: Signal<AllCourses> = toSignal(
    from(
      (async (): Promise<AllCourses> => {
        try {
          return await firstValueFrom(
            this.coursesService.getAllCourses(Number(this.activeRoute.snapshot.parent?.paramMap.get('coursesId'))) as Observable<AllCourses>
          );
        } catch (err: any) {
          if (err.status === 404) {
            this.router.navigate(['/error-course']);
            return new Promise<AllCourses>(() => {});
          }
          throw err;
        }})()), { initialValue: undefined as unknown as AllCourses }
  );
  public coursesId?: string;

  constructor() {
    this.coursesId = this.activeRouter.snapshot.parent?.paramMap.get('coursesId')!;
    effect(() => {
      this.allCourses();
      if (!this.allCourses() || !this.lesson()) return;

      if(this.allCourses().modules[0]?.lessons[0].id === this.lesson()?.id && !this.lesson()?.isCompleted ){
        this.isInformModal.update(value => !value)
        document.body.classList.add('no-scroll');
      }
    });
  }

  ngOnInit() {
    this.getCoursesProgress(Number(this.route.snapshot.paramMap.get('id')));
  }

  public getCoursesProgress(id: number) {
    this.lectionsService.getInfoLections(id)
      .pipe(takeUntilDestroyed(this.destroy),catchError( err => {
        if(err.status === 403){
          this.notificationService.show("error", err.error.detail, "");
          this.router.navigate(['/', this.activeRoute.snapshot.parent?.paramMap.get('coursesId')]);
        }
        return EMPTY;
        }
      )).subscribe(lections => {
        this.lesson.set(lections as Lection);
        if (lections?.videoUrl) {
          const embedUrl = this.videoConvercer.getSafeEmbedUrl(lections.videoUrl);
          this.videoUrl.set(embedUrl);
        }
      });
  }


  public closeInfoModal(){
    this.isInformModal.set(false)
    document.body.classList.remove('no-scroll');
  }

  public completeLection(lessonId: number) {

    this.isShowModal.set(false);
    document.body.classList.remove('no-scroll');

    this.lectionsService
      .completeLection(lessonId)
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe({
        next: () => {

          this.lesson.update(l => l ? { ...l, isCompleted: true } : l);

          if(this.lesson()?.isLastLessonInModule && this.lesson()?.isCompleted){
            this.isShowModal.set(true);
              document.body.classList.add('no-scroll');
          }
        },
        error: (err) => {

        }
      });
  }

  public goToLesson(lessonId: number | undefined) {
    this.videoUrl.set(null);

    if (!lessonId) return;
    this.router.navigate(
      ['../', lessonId],
      { relativeTo: this.route });

    this.lectionsService.getInfoLections(lessonId).pipe(takeUntilDestroyed(this.destroy)).subscribe(lections => {
      this.lesson.set(lections as Lection);
      if (lections?.videoUrl) {
        const embedUrl = this.videoConvercer.getSafeEmbedUrl(lections.videoUrl);
        this.videoUrl.set(embedUrl);
      }
    })
  }

  public goToCourses(){
    this.router.navigate(['/', this.activeRoute.snapshot.parent?.paramMap.get('coursesId')]);
    document.body.classList.remove('no-scroll');
  }

  public goToTest() {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.body.classList.remove('no-scroll');

    const currentLessonId = this.lesson()?.id;
    const modules = this.allCourses()?.modules ?? [];
    const index = modules.findIndex(module => module.lessons.some(lesson => lesson.id === currentLessonId));
    const moduleIndex = index !== -1 ? index + 1 : null;

    this.router.navigate([this.coursesId ,'testing','intermediate',moduleIndex])

  }

  public globalTest(){
    this.router.navigate([this.coursesId ,'testing', 'final', '1'])
    document.body.classList.remove('no-scroll');
  }
}
